module.exports = __webpack_public_path__ + "img/KH.72c948be.svg";